export default "__VITE_ASSET__d4e6cfce__"